export class State {
  public error = '';
  public holidayInitData = {
    holiday_name: '',
    holiday_date: '',
    is_recurring: false,
    description: ''
    // status: true,
  };
  public holiday = {};
  public holidays = [];
  public holidayCount = 0;
}